import { useSelector } from 'react-redux';

import { selectPortableMode } from '../containers/App/selectors';

export default function useEffectivePortableMode() {
  return useSelector(selectPortableMode);
}
